import FootballState from "../../../../../sports/football/state/football-state";
import { FragmentSerializer } from "./FragmentSerializer";

export class KickOffFragmentSerializer extends FragmentSerializer {
    applicable(fragment) {
        return fragment.associatedState === FootballState.KickOff;
    }

    getRawFragment(play, serializationContext, kickOff) {
        const kick = play.getFirstFragment(FootballState.Kick);
        const uniform = this.resolveUniform(
            serializationContext,
            kick.getPlayers()[0]
        );
        let values = [
            uniform,
            this.resolveFormattedFieldPosition(
                serializationContext,
                kickOff.kickedTo
            )
        ];

        let kickedFromSpot = "";

        const isCustomKickSpot =
            (kick.kickedFrom || kick.kickedFrom === 0) &&
            kick.kickedFrom !== play.contextSnapshot.fieldPosition;

        if (isCustomKickSpot) {
            const possession = this.resolveTeam(
                serializationContext,
                kick.kickedBy
            );
            const spot = this.resolveFormattedFieldPosition(
                serializationContext,
                kick.kickedFrom
            );
            kickedFromSpot = `SPOT:${possession},${spot},N `;
        }

        const rawPlay = `${kickedFromSpot}KO:${values.join()}`;
        return rawPlay;
    }
}
